import styled from 'styled-components';
import { colours } from '@cambridgeassessment/cambridge-ui';

interface Props {
  colored: boolean;
}

export const Row = styled.div<Props>`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  border-top: ${(props): string => (props.colored ? `solid 3px ${colours.black}09` : 'none')};
  background-color: ${(props): string => (props.colored ? `${colours.black}06` : colours.white)};
  padding: 15px 25px;
  font-size: 15px;
  max-width: 1016px;
`;

export const GetReportButton = styled.button`
  font-family: SourceSansPro;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  font-size: 15px;
  line-height: 1.5;
  letter-spacing: normal;
  text-decoration: underline;
  text-align: right;
  color: ${colours.scienceBlue};
  background: none;
  border: none;

  &:hover {
    cursor: pointer;
    color: ${colours.bluish};
  }

  &:focus {
    outline: none;
    color: ${colours.scienceBlue};
    background-color: rgba(46, 136, 204, 0.06);
  }

  &:active {
    color: ${colours.cobalt};
  }

  &:disabled {
    opacity: 0.3;
    color: ${colours.doveGray};
    cursor: not-allowed;
  }
`;
